export default class TableRequestItem {
    page = 1;
    pageSize = 8;
    lockItem: any = null;
    search = false;
    searchField = "all";
    searchKey = "";
    dateTime: any = null;
}
